module.exports = __webpack_public_path__ + "f12e91e5d03cd5ad84db8d674263cf7c.pdf";